<template>
  <div>
    <top-img-temp
    :imgUrl="topImg"
    :cName="cName"
    :e-name="eName"
    :d-text-show="dTextShow"
    :d-text-url="dTextUrl"
    :d-text-c="dTextC"
    :d-text-e="dTextE"
    ></top-img-temp>
    <div class="section2">
      <div>
        <div class="section2_con">
          <p class="bbTitl">{{isChinese ? tecDetail.cTitle : tecDetail.eTitle }}</p>
          <p class="bbText">{{isChinese ? dataObj.content : dataObj.contentEn }}</p>
        </div>
        <div class="section2_imgbox">
          <img :src="isChinese ? dataObj.pic1 : dataObj.pic1En" alt />
        </div>
      </div>
    </div>

    <div class="section3">
      <img  :src="isChinese ? dataObj.pic2 : dataObj.pic2En" alt />
      <div class="section3_con">
        <p class="bbTitl">{{isChinese ? tecDetail2.cTitle : tecDetail2.eTitle }}</p>
        <p class="bbText">{{isChinese ? tecDetail2.cCont : tecDetail2.eCont }}</p>
      </div>
    </div>

    <!-- <div class="section4">
      <div class style="margin-top: 5vw">
        <p class="bbTitl">{{isChinese ? tecDetail3.cTitle : tecDetail3.eTitle }}</p>
      </div>
      <div class="detail_img">
        <img :src="isChinese ? dataObj.pic3 : dataObj.pic3En" alt />
      </div>
    </div> -->

    <div class="section5">
      <div class style="margin-top: 4vw">
        <p class="bbTitl">{{isChinese ? tecDetail4.cTitle : tecDetail4.eTitle }}</p>
        <p class="bbText">{{isChinese ? tecDetail4.cCont : tecDetail4.eCont }}</p>
      </div>
      <div class="detail_img">
        <img :src="isChinese ? dataObj.pic4 : dataObj.pic4En" alt />
      </div>
    </div>
    <div class="section6">
      <div class style="margin-top: 4vw">
        <p class="bbTitl">{{isChinese ? tecDetail5.cTitle : tecDetail5.eTitle }}</p>
        <p class="bbText">{{isChinese ? tecDetail5.cCont : tecDetail5.eCont }}</p>
      </div>

      <div class="section6_con" style="width: 100vw;margin: 0 auto;height: auto;margin-top: 2vw">
        <el-carousel :interval="4000" type="card" width="100%">
          <el-carousel-item
            v-for="(item,index) in tecDetail5.list"
            @change="getItemIndex"
            :key="index">
            <div style="position: relative;width: 100%;height: 100%">
              <img :src="item.value" alt style="width: 100%;height: 100%" />
              <!-- <div class="abs">{{isChinese ? item.key : item.keyEn}}</div> -->
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="section7">
      <div class style="margin-top: 4vw">
        <p class="bbTitl">{{isChinese ? tecDetail6.cTitle : tecDetail6.eTitle }}</p>
        <p class="bbText">{{isChinese ? tecDetail6.cCont : tecDetail6.eCont }}</p>
      </div>
      <div class="section7_con">
        <div v-for="(item,index) in tecDetail6.list" :key="index" @click="downLoadFile(item.value)">
          <div class="imgbx">
            <img src="../../static/images/aboutUs/GYWM-27.jpg" alt />
          </div>
          <p class="ssss" :title="item.key">{{isChinese ? item.key : item.keyEn}}</p>
          <!-- <p class="ssss" :title="item.key">{{item.key }}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topImgTemp from "./baseTemp/topImgTemp";

export default {
  name: "solutionMore",
  data() {
    return {
      id: undefined,
      isChinese: undefined,
      topImg: "",
      cName: "热浸锌",
      eName: "News Center",
      dTextShow: true,
      dTextUrl: '/Solution',
      dTextC: '解决方案',
      dTextE: 'Solution',
      dataObj: {}, // 详细对象
      tecDetail: {
        cTitle: "技术介绍",
        eTitle: "Technology Introduction ",
        cCont:
          "热浸锌也称热浸镀锌，是钢铁构件浸入熔融的锌液中获得金属覆盖\n" +
          "层的一种方法。热浸锌具有较厚致密的纯锌层覆盖在紧固件表面,且\n" +
          "工业化程度高、处理费用低、质量稳定、因而被大量用于不易维修的\n" +
          "室外钢结构中，例如风机，轨道交通及户外电塔",
        eCont: "",
        img: require("../../static/images/base/XWZX-35.jpg")
      },
      tecDetail2: {
        cTitle: "工艺流程",
        eTitle: "Technological Process"
      },
      tecDetail3: {
        cTitle: "各主机厂执行标准",
        eTitle: "Executive Standards of main engine plants"
      },
      tecDetail4: {
        cTitle: "适应行业",
        eTitle: "Adapt to the industry",
        cCont: "理解客户所求,为客户提供全方位专业化服务",
        eCont:
          "Understand customers demands and provide customers with all-round professional services"
      },
      tecDetail5: {
        cTitle: "应用产品",
        eTitle: "Application products",
        cCont: "高效、简便并且面向未来",
        eCont: "Efficient, simple and future oriented",
        list: []
      },
      tecDetail6: {
        cTitle: "产品资料下载",
        eTitle: "Product information download",
        cCont: "我司相关技术资料可供浏览者下载",
        eCont:
          "The relevant technical data of our company can be downloaded by the viewer",
        list: []
      }
    };
  },
  created() {
    // if (localStorage.getItem("store")) {
    //   this.$store.replaceState(
    //     Object.assign(
    //       {},
    //       this.$store.state,
    //       JSON.parse(localStorage.getItem("store"))
    //     )
    //   );
    //   sessionStorage.removeItem("store");
    // }
    this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
    console.log(this.isChinese, "solutionMore");
    this.id = window.location.href.split("id=")[1];
    this.getMoreInfo(this.id);
  },
  computed: {
    setCAE() {
      return this.$store.state.cAeSatus;
    }
  },
  watch: {
    $route(to, from) {
      this.isChinese =
        localStorage.getItem("setCEcontrol") === "1" ? true : false;
    },
    setCAE(newVal) {
      this.isChinese = newVal === 1 ? true : false;
    }
  },
  components: {
    topImgTemp
  },
  methods: {
    getItemIndex(a, b) {
      console.log(a, b);
    },
    getMoreInfo(id) {
      this.$http
        .get("/jishi/api/case/info", {
          params: {
            id: id
          }
        })
        .then(
          function(res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.dataObj = resdata;
              this.topImg = resdata.cover;
              this.cName = resdata.business;
              this.eName = resdata.businessEn;

              // 应用产品
              this.tecDetail5.list = resdata.products;
              this.tecDetail6.list = resdata.documents;

              // // 富文本分割
              // let content = this.imgUrlFun(resdata.content) // 四张图片
              // this.tecDetail.img = content[0]
              // this.tecDetail2.img = content[1]
              // this.tecDetail3.img = content[2]
              // this.tecDetail4.img = content[3]
              //
              // this.tecDetail5.list = resdata.products
              // this.tecDetail6.list = resdata.documents
            }
          }.bind(this)
        );
    },
    imgUrlFun(html) {
      let data = [];
      if (html) {
        html.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, function(
          match,
          capture
        ) {
          data.push(capture);
        });
      }
      return data;
    },
    downLoadFile (fileUrl) {
        window.open(fileUrl, "_blank");
      }
  }
};
</script>

<style scoped>
.detail_img{
  width: 70%;
  margin: 0 auto;
  margin-top: 3vw
}
img {
  width: 100%;
}
.bbTitl {
  text-align: center;
  color: #595757;
  font-size: 3rem;
  font-family: Medium;
}
.bbText {
  width: 45%;
  margin: 0 auto;
  text-align: center;
  color: #787878;
  margin-top: 2vw;
  font-size: 1.5rem;
  line-height: 25px;
}
.section2 {
  margin-top: 6vw;
  margin-bottom: 4vw;
}

.section2 > div {
  display: flex;
  justify-content: flex-end;
}

.section2_con {
  width: 35%;
  padding-right: 3vw;
  display: flex;
  flex-flow: column;
  justify-content: center;
}
.section2_con > p {
  /*background: red;*/
  width: 100%;
  text-align: left;
}
.section2_imgbox {
  width: 50%;
}
@media screen and (max-width: 800px) {
  .section2 > div {
    display: block;
  }
  .section2_con {
    width: 90%;
    margin: 0 auto;
  }
  .section2_con > p {
    text-align: center;
  }
  .section2_imgbox {
    width: 100%;
    text-align: center;

  }
  .section2_imgbox img {
    width: 95%;
    margin-top: 5px;
  }
  .bbText {
  width: 100% !important;
  /* margin: 0 auto;
  text-align: center;
  color: #787878;
  margin-top: 2vw;
  font-size: 1.5rem;
  line-height: 25px; */
}
.bbTitl{
  margin: 0 !important;
}
.detail_img{
  width: 95%;
}
}
.section3 {
  width: 100%;
  height: auto;
  /*background: url("../../static/images/solution/RJX-25.jpg");*/
  background-size: 100% 100%;
  position: relative;
}
.section3_con {
  position: absolute;
  width: 100%;
  top: 1vw;
}
@media screen and (max-width: 800px) {
  /* .section3_con {
    top: -6vw;
  } */
}
.section3_con > p {
  padding-top: 3vw;
}

.section6_con >>> .el-carousel__container {
  height: 35vw !important;
}
.section7 {
  padding: 5vw 0;
  background: #efefef;
  margin-top: 4vw;
}
.section7_con {
  display: flex;
  justify-content: center;
  margin-top: 2vw;
}
.section7_con > div {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  background: white;
  cursor: pointer;
  padding: 18px 10px;
  /*width: 10vw;*/
  margin-left: 10px;
}
.section7_con > div:hover {
  box-shadow: 2px 3px 5px #c2c2c2;
}
.imgbx {
  width: 20px;
}
.ssss {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
@media screen and (max-width: 800px) {
  .section7_con {
    display: block;
    width: 95%;
    margin: 0 auto;
  }
  .section7_con > div {
    margin-top: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 0;
  }
}
.abs {
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  width: 100%;
  /*bottom: 40px;*/
  bottom: 0;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  z-index: 999;
  visibility: hidden;
}
.section6_con >>> .is-active .abs {
  visibility: visible

}
</style>



// WEBPACK FOOTER //
// src/components/solutionMore.vue